import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  nowDate: number;

  constructor() { 
    this.nowDate = new Date().getFullYear();
  }

  ngOnInit() {
  }

}
